import { Chat, ChatAttachment } from '@src/api/shared/community/chatApiClient';
import { CHAT_ATTACHABLE_FILE_EXTENSION_CLASSIFICATION } from '@src/enum/chatAttachableFileExtension';
import ChatFileList from '@src/features/shared/community/components/chat/chatList/ChatFileList';
import ChatImageList from '@src/features/shared/community/components/chat/chatList/ChatImageList';
import { Attachment } from '@src/utils/idb';
import React from 'react';

export type ChatAttachmentListProps = {
  className?: string;
  attachments?: Attachment[];
  chat: Chat;
  hasMessageContent?: boolean;
  allowImagePreview?: boolean;
  keyword?: string;
  includeImagesInFiles?: boolean;
};

export type ChatAttachmentItemProps = {
  attachment: ChatAttachment;
  chat: Chat;
  showTooltip?: boolean;
  displayTooltip?: (duration: number) => void;
  allowImagePreview?: boolean;
  keyword?: string;
};

const ChatAttachmentList: React.FC<ChatAttachmentListProps> = ({
  attachments = [],
  hasMessageContent = false,
  chat,
  allowImagePreview = true,
  className = '',
  keyword = '',
  includeImagesInFiles = false,
}) => {
  if (attachments.length === 0) {
    return null;
  }

  const imageAttachments = attachments.filter((att) => {
    const ext = (att.chatAttachment?.extension || att.name.split('.').pop() || '').toLowerCase();
    return CHAT_ATTACHABLE_FILE_EXTENSION_CLASSIFICATION.VIEWABLE_FILES.includes(ext);
  });

  const fileAttachments = attachments.filter((att) => {
    const ext = (att.chatAttachment?.extension || att.name.split('.').pop() || '').toLowerCase();
    const isImageFile = CHAT_ATTACHABLE_FILE_EXTENSION_CLASSIFICATION.VIEWABLE_FILES.includes(ext);

    return includeImagesInFiles ? true : !isImageFile;
  });

  return (
    <>
      {!includeImagesInFiles && imageAttachments.length > 0 && (
        <div className={`${hasMessageContent ? 'mt-4' : ''} pl-1 lg:pl-0 ${className}`}>
          <ChatImageList
            attachments={imageAttachments}
            chat={chat}
            allowImagePreview={allowImagePreview}
          />
        </div>
      )}
      {fileAttachments.length > 0 && (
        <div
          className={`${hasMessageContent || (!includeImagesInFiles && imageAttachments.length > 0) ? 'mt-4' : ''} pl-1 lg:pl-0 ${className}`}
        >
          <ChatFileList
            attachments={fileAttachments}
            chat={chat}
            keyword={keyword}
          />
        </div>
      )}
    </>
  );
};

export default ChatAttachmentList;
